"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _components = require("../../components");

var _gridSystem = _interopRequireDefault(require("../../utils/grid-system"));

var _utils = require("../../utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Pretitle = _styledComponents["default"].span.withConfig({
  displayName: "hdi-one-column__Pretitle",
  componentId: "sc-14cmcrx-0"
})(["text-transform:uppercase;letter-spacing:4px;"]);

var propTypes = {
  /** Background color */
  backgroundColor: _propTypes.string,

  /** Custom Background Image source */
  backgroundImage: (0, _propTypes.oneOfType)([(0, _propTypes.arrayOf)(_propTypes.string), _propTypes.string]),

  /** setting for bottom padding amount */
  bottomUnitPadding: _propTypes.number,

  /** Children, a node or can be a React component */
  children: _propTypes.node,

  /** ClassName for Section */
  className: _propTypes.string,

  /** Allows modification of container styles */
  containerProps: (0, _propTypes.shape)({
    px: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.array])
  }),

  /** Custom Background */
  customBackground: _propTypes.func,

  /** A boolean to set whether the dark version of the cta is used */
  darkUi: _propTypes.bool,

  /** Description usually a string, but can be a node */
  description: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),

  /** String for id to pass to component */
  htmlId: _propTypes.string,

  /** Image source usally string, but can be a react node */
  imageAbove: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),

  /** Image source usally string, but can be a react node */
  imageBelow: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),

  /** Pretitle, usually a text string */
  pretitle: _propTypes.string,

  /** Theme config object */
  theme: _utils.themePropType,

  /** Title text text usually a text */
  title: _propTypes.string,

  /** setting for top padding amount * */
  topUnitPadding: _propTypes.number
};
var defaultProps = {
  bottomUnitPadding: 2,
  topUnitPadding: 2
};

var HDIOneColumn = function HDIOneColumn(_ref) {
  var backgroundColor = _ref.backgroundColor,
      backgroundImage = _ref.backgroundImage,
      containerProps = _ref.containerProps,
      bottomUnitPadding = _ref.bottomUnitPadding,
      children = _ref.children,
      className = _ref.className,
      customBackground = _ref.customBackground,
      darkUi = _ref.darkUi,
      description = _ref.description,
      htmlId = _ref.htmlId,
      imageAbove = _ref.imageAbove,
      imageBelow = _ref.imageBelow,
      pretitle = _ref.pretitle,
      theme = _ref.theme,
      title = _ref.title,
      topUnitPadding = _ref.topUnitPadding;
  var descriptionFont = {
    color: darkUi ? "text-light" : "text",
    fontSize: [4, 4, 4, 4, 5],
    fontWeight: 1,
    lineHeight: [2, 2, 3],
    textAlign: "center"
  };
  var pretitleFont = {
    alignItems: "center",
    color: darkUi ? "text-light" : "legal-grey",
    fontSize: [2, 3],
    fontWeight: 1,
    lineHeight: 3,
    mb: [1, 2, 2, 2, 3]
  };
  var titleFont = {
    color: darkUi ? "text-light" : "text-title",
    fontSize: [8, 9, 10, 10, 11],
    fontWeight: 2,
    lineHeight: [2, 2, 1, 1, 1, 1],
    mb: [1, 2, 3],
    textAlign: "center"
  };
  var defaultBg = darkUi ? "background-dark" : "background";
  return /*#__PURE__*/_react["default"].createElement(_gridSystem["default"].Wrapper, {
    backgroundColor: backgroundColor || defaultBg,
    backgroundImage: backgroundImage,
    className: className,
    containerProps: containerProps,
    htmlId: htmlId,
    tag: customBackground
  }, /*#__PURE__*/_react["default"].createElement(_gridSystem["default"].Container, {
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
    pb: theme && theme.unitPadding && theme.unitPadding.map(function (padding) {
      return bottomUnitPadding * padding;
    }),
    pt: theme && theme.unitPadding && theme.unitPadding.map(function (padding) {
      return topUnitPadding * padding;
    }),
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_gridSystem["default"].Element, {
    alignItems: "center",
    columns: [6, 8, 12, 10, 8, 10],
    flexDirection: "column",
    justifyContent: "center",
    px: [0, 0, "12px", "12px", 2]
  }, /*#__PURE__*/_react["default"].createElement(_components.PanelContent, {
    alignItems: "center",
    description: description,
    descriptionFont: descriptionFont,
    imageAbove: imageAbove,
    imageBelow: imageBelow,
    imageSpacing: [1, 2, 2, 2, 3],
    justifyContent: "center",
    pretitle: pretitle && /*#__PURE__*/_react["default"].createElement(Pretitle, null, pretitle),
    pretitleFont: pretitleFont,
    title: title,
    titleFont: titleFont
  }), children)));
};

HDIOneColumn.propTypes = propTypes;
HDIOneColumn.defaultProps = defaultProps;
HDIOneColumn.displayName = "Modules.HDIOneColumn";

var _default = (0, _styledComponents.withTheme)(HDIOneColumn);

exports["default"] = _default;